import { styled } from "@mui/material";

import { GetIconByName } from "@/Components";
import { BackBurger } from "@/Components/Icons/BackBurger";
import { Box } from "@/Components/v2/atoms/Box";
import { SimpleIconButton } from "@/Components/v2/atoms/Button";
import { Typography } from "@/Components/v2/atoms/Typography";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

export interface HeaderMenuItem {
  key: string;
  label: string;
  route: string;
  onClick?: (() => void) | undefined;
  icon: React.ReactNode;
  hasAccess: boolean;
}

interface DrawerHeaderProps {
  subheader: string;
  toggleDrawer: () => void;
  hideIcon: boolean;
}

const StyledDrawerHeader = styled("div")(() => ({
  marginBottom: "1rem",
}));

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  subheader,
  toggleDrawer,
  hideIcon,
}) => {
  const { theme } = useInfo();

  const handleToggleDrawer = () => {
    toggleDrawer();
  };

  return (
    <StyledDrawerHeader>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <GetIconByName name={"LogoWithName"} themeColor={theme.color} />
        {!hideIcon && (
          <SimpleIconButton
            onClick={handleToggleDrawer}
            aria-label="close drawer"
            color="inherit"
            sx={{
              marginBottom: 0.5,
            }}
            data-testcomp="CloseDrawer"
          >
            <BackBurger />
          </SimpleIconButton>
        )}
      </Box>
      <Typography
        sx={{
          fontSize: ".8rem",
          fontWeight: "600",
        }}
      >
        {subheader}
      </Typography>
    </StyledDrawerHeader>
  );
};

export default DrawerHeader;
